import { attachmentFilename } from '#lib/attachmentFilename';
import { fetcher } from '#lib/backendFetcher';

/**
 * Exports campaign send data as a CSV file. The rows are either explicit sends or every send
 * matching the sends-table filters (resolved by the backend).
 * @param {string} campaignId - UUID of the campaign
 * @param {Object} options
 * @param {Array<string>} options.columns - Column keys to export
 * @param {string[]} [options.sendIds] - Explicit sends; XOR with selectAll
 * @param {boolean} [options.selectAll] - Every send matching `filters` (all sends without filters)
 * @param {{status?: string[], search?: string}} [options.filters] - Sends-table filters, only with selectAll
 * @returns {Promise<{blob: Blob, filename: string}>}
 */
export const exportCampaignToCSV = async (campaignId, options) => {
	const response = await fetcher(`/api/v1/email/campaigns/${campaignId}/export-csv`, {
		method: 'POST',
		body: options,
		responseType: 'stream',
	});

	const filename = attachmentFilename(response.headers.get('Content-Disposition'), 'kampagne_export.csv');
	const blob = await response.blob();
	return { blob, filename };
};
